import React from 'react';
import Typewriter from 'typewriter-effect';

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          'Software Engineer (Web)',
          'Completed Bachelor of Engineering(4year) in Computer Science and Engineering(CSE)',
          'Javascript Specialist',
          'PHP Specialist',
          'Have 7+ Working Experience as a Software Engineer',
          'Have Wide Knowledge in Next.js(React.js framework) and Laravel',
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
